import classNames from 'classnames';
import './TileGradient.scss';

export interface TileGradientProps {
  hidden?: boolean;
  className?: string;
  position?: 'top' | 'bottom';
}

/**
 * Tile Gradient Component
 * @param hidden - If true, the component is hidden.
 * @param className - Additional className to extend its style.
 * @constructor
 */
export const TileGradient: React.FC<TileGradientProps> = ({
  hidden = false,
  position = 'top',
  className,
  ...rest
}) => {
  if (hidden) return null;

  return (
    <div
      className={classNames(
        'vds-tile-gradient',
        position === 'bottom' && 'vds-tile-gradient--transform',
        className,
      )}
      {...rest}
    />
  );
};
